export { default } from './MasteryIcon';
